<template>
  <v-data-table
    :headers="headers"
    :items="items"
    :search="search"
    :custom-filter="unaccent"
    :loading="loading"
    v-bind="{$scopedSlots}"
    :options.sync="localOptions"
    :server-items-length="countItems"
    :footer-props="footerOptions"
  />
</template>
<script>

  export default {
    name: 'DataGrid',
    props: {
      headers: {
        type: Array,
      },
      search: {
        type: String,
        default: '',
      },
      items: {
        type: Array,
        default: () => [],
      },
      loading: {
        type: Boolean,
      },
      countItems: {
        type: Number,
      },
      options: {
        type: Object,
      },
      footerOptions: {
        type: Object,
        default: () => ({ 'items-per-page-options': [5, 10, 15, 20] }),
      },
    },
    data () {
      return {
        localOptions: this.options,
      }
    },
    watch: {
      localOptions (newOptions) {
        this.$emit('update:options', newOptions)
      },
    },
    methods: {
      unaccent (value, search, item) {
          console.log('pelo menos me chamaram')
        if (!(value != null && search != null)) return false
        value = value.toString().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase()
        search = search.toString().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase()
        return value.indexOf(search) !== -1
      },
    },
  }
</script>
